import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { Form } from "semantic-ui-react";
import { CloneL2, L2CloneRequest } from "../../../../services/NetworkApi";
import { useNetworkContext } from "../../../../contexts/NetworkContext/context";
import { getDefaultDateNonNull, getDefaultDate } from "../../../../helpers/getDefaultDate";
import { MatchingDatesPartial } from "../../../../components/MatchingDatesPartial";

import useAuth from "../../../login/AuthContext";
interface CloneSubnetworkModalProps {
  show: boolean;
  onClose: () => void;
  l2Name: string;
  l1Id: number;
  l2Id: number;
  matchingRoundStatus: string | null;
  matchingStartDate: string;
  matchingEndDate: string;
  activationStartDate: string;
  activationEndDate: string;
}

export const CloneSubnetworkModal: React.FunctionComponent<CloneSubnetworkModalProps> = ({
  show,
  onClose,
  l2Name,
  l1Id,
  l2Id,
  matchingRoundStatus,
  matchingStartDate,
  matchingEndDate,
  activationStartDate,
  activationEndDate
  
}) => {
  const { loadNetworkInfoForNetworks } = useNetworkContext();
  const { getAuthToken } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const defaultRequestFields = {
    l1IdSource: l1Id,
    l2IdSource: l2Id,
    subNetworkName: "",
    seasonId: undefined,
    grouping: undefined,
    matchingStartDate: matchingStartDate && getDefaultDateNonNull(matchingStartDate).format("YYYY-MM-DD"),
    matchingEndDate: matchingEndDate && getDefaultDateNonNull(matchingEndDate).format("YYYY-MM-DD"),
    activationStartDate: activationStartDate && getDefaultDateNonNull(activationStartDate).format("YYYY-MM-DD"),
    activationEndDate: activationEndDate && getDefaultDateNonNull(activationEndDate).format("YYYY-MM-DD")
  };
  const [requestFields, setRequestFields] = useState<L2CloneRequest>(defaultRequestFields);

  const defaultErrors = {
    subnetworkNameError: false,
    matchingDatesError: false,
    closedArchivedError: false
  };
  const [errors, setErrors] = useState(defaultErrors);

  const setDateValues = (value: string | boolean | null, field: string) => {
    setRequestFields({...requestFields, [field]: value });
  };

  const resetData = () => {
    setRequestFields(defaultRequestFields);
    setErrors(defaultErrors);
    setIsSubmitting(false);
  };

  const validateFields = () => {
    const validationErrors = { ...errors };

    let errored = false;

    validationErrors.subnetworkNameError = requestFields.subNetworkName == undefined;
    errored = errored || requestFields.subNetworkName == undefined;

    const isEveryDateIsSet = (requestFields.matchingStartDate !== null && requestFields.matchingEndDate !== null && requestFields.activationStartDate !== null && requestFields.activationEndDate !== null);
    const isEveryDateIsNull = (requestFields.matchingStartDate === null && requestFields.matchingEndDate === null && requestFields.activationStartDate === null && requestFields.activationEndDate === null);
    if(isEveryDateIsSet === false && isEveryDateIsNull === false) {
      validationErrors.matchingDatesError = true;
    }
    errored = errored || validationErrors.matchingDatesError;
    
    validationErrors.closedArchivedError = requestFields.activationEndDate && requestFields.matchingEndDate?
      !!getDefaultDate(requestFields.activationEndDate)?.isBefore(new Date()) || !!getDefaultDate(requestFields.matchingEndDate)?.isBefore(new Date()) : false;
    
    errored = errored || validationErrors.closedArchivedError;
    
    setErrors(validationErrors);
    return !errored;
  };

  const onSubmit = async (event?: React.FormEvent) => {
    if (event) {
      event.preventDefault();
    }

    if (isSubmitting) {
      return;
    }

    if (validateFields()) {
      setIsSubmitting(true);

      try {
        await CloneL2(requestFields, await getAuthToken());
        await loadNetworkInfoForNetworks([l1Id]);
        onClose();
      } catch (error) {
        // console.error("Error cloning subnetwork:", error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={onClose} onExiting={resetData}>
      <Modal.Header closeButton>
        <Modal.Title>Clone {l2Name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form
          error={errors.subnetworkNameError}
          onSubmit={onSubmit}
        >
          <Form.Field error={errors.subnetworkNameError}>
            <label>L2 Name</label>
            <input
              onChange={(event) => {
                setRequestFields({
                  ...requestFields,
                  subNetworkName: event.target.value,
                });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Season Id</label>
            <input
              onChange={(event) => {
                setRequestFields({
                  ...requestFields,
                  seasonId: event.target.value,
                });
              }}
            />
          </Form.Field>
          <Form.Field>
            <label>Grouping</label>
            <input
              onChange={(event) => {
                setRequestFields({
                  ...requestFields,
                  grouping: event.target.value,
                });
              }}
            />
          </Form.Field>
          <MatchingDatesPartial
            matchingRoundStatus={matchingRoundStatus}
            activationStartDate={activationStartDate}
            activationEndDate={activationEndDate}
            matchingStartDate={matchingStartDate}
            matchingEndDate={matchingEndDate}
            matchingDatesError={errors.matchingDatesError}
            closedArchivedError={errors.closedArchivedError}
            setValue={setDateValues}
          />
          <Button
            style={{ marginTop: "5px" }}
            type="submit"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Cloning..." : "Add"}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
};
